import { render, staticRenderFns } from "./Subheader.vue?vue&type=template&id=9d37c724"
import script from "./Subheader.vue?vue&type=script&lang=js"
export * from "./Subheader.vue?vue&type=script&lang=js"
import style0 from "./Subheader.vue?vue&type=style&index=0&id=9d37c724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports